<template>
  <div class="accountMgt">
    <nav>
      <div class="one-left">
        <div>
          <span class="shu"></span>
          <span>账户管理</span>
        </div>
        <div class="edit" @click="editModal = true;">
          <span>变更</span>
          <img src="../../assets/imgs/qiyeziliao/ziliao4.png" alt="edit" />
        </div>
      </div>
    </nav>
    <section>
      <div class="line">
        <div class="item">
          <div class="name">提现账户</div>
          <div class="input">{{txAccountNo}}</div>
        </div>
        <div class="item">
          <div class="name">提现账户名称</div>
          <div class="input">{{txAccountName}}</div>
        </div>
      </div>
      <div class="line">
        <div class="item">
          <div class="name">提现账户开户行</div>
          <div class="input">{{txAccountBank}}</div>
        </div>
        <div class="item">
          <div class="name">交易预付款账户</div>
          <div class="input">{{tradeBankAccount}}</div>
        </div>
      </div>
    </section>
    <div class="mask" v-show="editModal">
      <div v-show="editModal" class="pop1-box">
        <div class="top flexrcc">
          <div class="title">变更账户信息</div>
          <img @click="closeModal" src="../../assets/imgs/home/close.png" alt />
        </div>
        <div class="content">
          <div class="item flexc0s">
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">提现账户</div>
            </div>
            <input type="text" v-model="txAccountNo" class="name-input" />
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">提现账户名称</div>
            </div>
            <input type="text" v-model="txAccountName" class="name-input" />
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">提现账户开户行</div>
            </div>
            <input type="text" v-model="txAccountBank" class="name-input" />
            <div class="title-box flexr0c">
              <span>*</span>
              <div class="title">提现账户联行号
                <a href="http://www.lianhanghao.com/" target="_blank">(查询联行号)</a>
              </div>
            </div>
            <input type="text" v-model="txAccountBknum" class="name-input" />
            <p class="warn">提示：请仔细核对相关信息！</p>
          </div>
        </div>
        <div class="bottom flexrcc">
          <Button class="save" :loading="loading" @click="save">保存</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "accountMgt",
  data () {
    return {
      editModal: false,
      loading: false,
      txAccountNo: "",
      txAccountName: "",
      txAccountBank: "",
      tradeBankAccount: "",
      txAccountBknum: ""
    }
  },
  created () {
    this.searchCountInfo();
  },
  methods: {
    searchCountInfo () {
      const session = JSON.parse(localStorage["session"]);
      this.$http.post({
        sessionId: session.sessionId,
        userId: session.userId,
        enterpriseId: session.enterpriseId,
        modeCode: "xSjEKJCWElHZ9i1enkW2Ad8WYKMwJcf2",
      }).then((res) => {
        if (res.code == 1) {
          const info = res.data;
          this.txAccountNo = info.txAccountNo || "";
          this.txAccountName = info.txAccountName || "";
          this.txAccountBank = info.txAccountBank || "";
          this.tradeBankAccount = info.tradeBankAccount || "";
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    trim (str, type) {
      // 没传类型去除所有空格
      type = type || "all";
      switch (type) {
        case "all": // 所有空格
          return str.replace(/\s+/g, "");
        case "around": // 前后空格
          return str.replace(/(^\s*)|(\s*$)/g, "");
        case "front": // 前空格
          return str.replace(/(^\s*)/g, "");
        case "back": // 后空格
          return str.replace(/(\s*$)/g, "");
        default:
          return str;
      }
    },
    closeModal () {
      this.editModal = false;
    },
    save () {
      if (!this.txAccountNo) {
        this.$Message["error"]({
          background: true,
          content: "请填写提现账户！",
        });
        return;
      }
      if (this.txAccountNo.length > 30) {
        this.$Message["error"]({
          background: true,
          content: "账户长度不超过30！",
        });
        return;
      }
      if (!this.txAccountName) {
        this.$Message["error"]({
          background: true,
          content: "请填写账户名称！",
        });
        return;
      }
      if (this.txAccountName.length > 50) {
        this.$Message["error"]({
          background: true,
          content: "账户名称长度不超过50！",
        });
        return;
      }
      if (!this.txAccountBank) {
        this.$Message["error"]({
          background: true,
          content: "请填写账户开户行！",
        });
        return;
      }
      if (this.txAccountBank.length > 50) {
        this.$Message["error"]({
          background: true,
          content: "账户名称长度不超过50！",
        });
        return;
      }
      if (!this.txAccountBknum) {
        this.$Message["error"]({
          background: true,
          content: "请填写账户联行号！",
        });
        return;
      }
      if (this.txAccountBknum.length > 30) {
        this.$Message["error"]({
          background: true,
          content: "账户联行号长度不超过50！",
        });
        return;
      }
      this.loading = true;
      const session = JSON.parse(localStorage["session"]);
      this.txAccountNo = this.trim(this.txAccountNo);
      this.txAccountName = this.trim(this.txAccountName);
      this.txAccountBank = this.trim(this.txAccountBank);
      this.txAccountBknum = this.trim(this.txAccountBknum);
      this.$http.post({
        sessionId: session.sessionId,
        userId: session.userId,
        id: session.enterpriseId,
        modeCode: "YBIpDs3i86QDQdlO9Sta4fC6hb5b3lZP",
        txAccountNo: this.txAccountNo,
        txAccountName: this.txAccountName,
        txAccountBank: this.txAccountBank,
        txAccountBknum: this.txAccountBknum
      }).then(res => {
        this.loading = false;
        if (res.code == 1) {
          this.isDisable = true;
          this.$Message["success"]({
            background: true,
            content: "修改成功！",
          });
          this.editModal = false;
          this.searchCountInfo();
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.accountMgt {
  width: 980px;
  height: 100%;
  text-align: center;
  border-radius: 10px;
  margin-left: 20px;
  background: #fff;
  nav {
    background-image: linear-gradient(180deg, #ffffff 0%, #e8e9ea 100%);
    border-radius: 10px 10px 0 0;
    width: 100%;
    height: 40px;
    line-height: 40px;
    box-sizing: border-box;
    padding: 0 10px;

    .one-left {
      color: #2c59c3;
      font-weight: 600;
      margin-left: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .shu {
        display: inline-block;
        width: 4px;
        height: 14px;
        background-color: #2c59c3;
        margin-right: 6px;
        vertical-align: middle;
        margin-top: -2px;
      }

      .edit {
        cursor: pointer;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #afb4c0;
        letter-spacing: 0.3px;

        img {
          margin-left: 5px;
        }
      }
    }
  }
  section {
    background: #fff;
    width: 100%;
    border-radius: 0 0 10px 10px;
    box-sizing: border-box;
    padding: 10px 26px 30px;
    .line {
      display: flex;
      .item {
        width: 368px;
        height: 100px;
        display: flex;
        flex-direction: column;
        margin-left: 60px;
        text-align: left;
        .name {
          margin: 10px 0;
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #9097a9;
          letter-spacing: 0.26px;
          margin-top: 20px;
        }
        .input {
          height: 47px;
          line-height: 47px;
          background: #f5f7fa;
          border-radius: 8px;
          box-sizing: border-box;
          padding-left: 20px;
        }
      }
    }
  }

  .mask {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;

    .pop1-box {
      position: absolute;
      width: 480px;
      height: 560px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 2;

      .top {
        width: 100%;
        height: 46px;
        background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
        border-radius: 10px 10px 0 0;

        .title {
          font-family: PingFangSC-Semibold;
          font-size: 18px;
          color: #ffffff;
          letter-spacing: 0.34px;
        }

        img {
          position: absolute;
          float: right;
          width: 16px;
          height: 16px;
          right: 15px;
          cursor: pointer;
        }
      }

      .content {
        width: 100%;
        height: 460px;
        background: #fff;
        overflow: hidden;

        .item {
          width: 368px;
          height: 405px;
          margin-top: 8px;
          margin-left: 56px;

          .name-input,
          /deep/.ivu-input {
            width: 368px;
            height: 48px;
            border-radius: 8px;
            padding-left: 24px;
          }

          .title-box {
            margin: 14px 0 8px 0;

            span {
              color: #d0021b;
              margin-right: 5px;
            }

            /deep/ .ivu-radio-wrapper {
              font-family: PingFangSC-Regular;
              font-size: 16px;
              color: #4a4a4a;
              letter-spacing: 0.3px;
            }

            .title {
              font-family: PingFangSC-Semibold;
              font-size: 16px;
              color: #9097a9;
              letter-spacing: 0.3px;
              line-height: 22px;
            }
          }
        }
      }

      .warn {
        margin: 10px 0;
        color: #d0021b;
        font-weight: 600;
      }

      .bottom {
        background: #f5f5f5;
        border-radius: 0 0 10px 10px;
        height: 50px;

        .edit {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
          border: 1px solid #285ed3;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #ffffff;
          letter-spacing: 0;
          margin-left: 16px;
          cursor: pointer;

          &:hover {
            background-image: linear-gradient(180deg, #5295f5 0%, #2559d1 99%);
          }
        }

        .save {
          width: 138px;
          height: 30px;
          line-height: 30px;
          background-image: linear-gradient(180deg, #f5515f 0%, #9f041b 100%);
          border: 1px solid #af1228;
          border-radius: 4px;
          font-family: PingFangSC-Medium;
          font-size: 14px;
          color: #fff;
          letter-spacing: 0;
          cursor: pointer;
          &:hover {
            background-image: linear-gradient(180deg, #ff7d89 0%, #b4051f 100%);
          }
        }
      }
    }
  }
}
</style>